<template>
  <v-select
    v-model="model"
    :items="items"
    :label="label"
    :prepend-icon="icon"
    :clearable="true"
    multiple
    chips
    deletable-chips
    dense
    item-text="name"
    item-value="id"
    @change="signalChange"
  ></v-select>
</template>

<script>
export default {
  name: "UserSelectMultiple",
  props: {
    autoclear: {
      type: Boolean,
      default: false,
    },
    showEmpty: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "mdi-account-circle",
    },
    label: {
      type: String,
      default: "User",
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    items: [],
    loading: false,
    search: "",
  }),
  computed: {
    model: {
      get: function () {
        return this.value
          ? Object.keys(this.value).length
            ? this.value
            : null
          : null;
      },
      set: function (val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    model() {
      this.$nextTick(() => {
        if (this.autoclear) {
          this.search = "";
          this.model = null;
        }
      });
      if (this.showEmpty)
        this.items.push({ name: "Unassigned", id: "unassigned" });
    },
    search() {
      this.getUsers();
    },
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    signalChange: function (event) {
      this.$emit("change", event);
    },
    getUsers() {
      // Items have already been requested
      if (this.loading) {
        return;
      }

      this.loading = true;

      let filter = {
        page: {
          number: 1,
          size: 200,
        },
        filter: {},
        include: "address,tags",
      };

      if (this.search) {
        filter.filter.search = this.search;
      }

      this.$models.User.all(filter)
        .then((response) => {
          response.data.forEach((responseData) => {
            responseData.tags.forEach((tag) => {
              if (tag.id == 20000) {
                this.items.push(responseData);
              }
            });
          });
          this.items.push(this.model);
          if (this.showEmpty)
            this.items.push({ name: "Unassigned", id: "unassigned" });
          this.loading = false;
        })
        .catch((error) => {
          this.$bus.$emit("Error", error);
        });
    },
  },
};
</script>
